/**
 * Add responsiveness to tables (wrap table in div with correct styles)
 * @class
 */
class ResponsiveTable {
  constructor(private element:HTMLElement, private wrapperClass:string) {

  }

  public init () {

    if(this.element) {
      var wrapperDiv = document.createElement('div'),
          parentNode = this.element.parentNode;

      wrapperDiv.classList.add(this.wrapperClass);
      parentNode.insertBefore(wrapperDiv, this.element);
      wrapperDiv.appendChild(this.element);
    }
  }
}

export { ResponsiveTable };
